import React, { useState } from "react";
import { Save } from "lucide-react";
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { Button, Grid } from "@mui/material";
import Modal from "../../components/Modal/Modal";
import InputLabel from "../../components/Inputs/InputLabel";
import SimpleBackdrop from "../../components/Loading/Simplebackdrop";
import { AlertInfo } from "../../components/Alerts/Alert";
import { api } from "../../services/api";

type ModalNovoTextoProps = {
    open: boolean,
    setOpen: React.Dispatch<React.SetStateAction<boolean>>
    reload: () => void
}

type FormProps = {
    tipo_paragrafo: string
    variavel: string
    paragrafo: string
}

export default function ModalNovoTexto({ open, setOpen, reload }: ModalNovoTextoProps) {
    const [load, setLoad] = useState(false);

    const initialValues: FormProps = {
        tipo_paragrafo: "",
        variavel: "",
        paragrafo: ""
    }

    const validationSchema = Yup.object({
        tipo_paragrafo: Yup.string().required('Descrição é obrigatoria'),
        variavel: Yup.string().required('Variavel é obrigatoria').matches(/^[a-z0-9_]+$/, 'Somente letras minusculas, numero e _').min(3, 'Variavel muito curta'),
        paragrafo: Yup.string().required('Paragrafo é obrigatorio'),
    });

    async function handleSaveText(values: FormProps) {
        setLoad(true);
        try {
            const response = await api.post(`/createparagrafopadrao`, values);
            if (response.data.success) AlertInfo({ icon: 'success', title: 'Dados Gravados' }).then(() => {
                setOpen(false);
                formik.resetForm();
                reload();
            });
        } catch (error) {
            console.log(error);
            AlertInfo({ icon: 'error', title: 'Falha na conexão' });
        }
        setLoad(false);
    }

    const formik = useFormik({
        initialValues,
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            handleSaveText(values);
        },
    });

    return (
        <Modal
            open={open}
            setOpen={setOpen}
            title="Novo Texto Padrão"
            maxWidth="md"
            zIndex={2222}
            actionClose={formik.resetForm}
        >
            <SimpleBackdrop open={load} zIndex={9999} />

            <Grid container spacing={1}>
                <Grid size={{ xs: 12, sm: 6 }}>
                    <InputLabel
                        id="tipo_paragrafo"
                        name="tipo_paragrafo"
                        label="Descrição"
                        value={formik.values.tipo_paragrafo}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.tipo_paragrafo && Boolean(formik.errors.tipo_paragrafo)}
                        helperText={formik.touched.tipo_paragrafo && formik.errors.tipo_paragrafo}
                    />
                </Grid>
                <Grid size={{ xs: 12, sm: 6 }}>
                    <InputLabel
                        id="variavel"
                        name="variavel"
                        label="Varialvel"
                        value={formik.values.variavel}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.variavel && Boolean(formik.errors.variavel)}
                        helperText={formik.touched.variavel && formik.errors.variavel}
                    />
                </Grid>
                <Grid size={12}>
                    <InputLabel
                        id="paragrafo"
                        name="paragrafo"
                        label="Texto"
                        multiline
                        rows={10}
                        value={formik.values.paragrafo}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.paragrafo && Boolean(formik.errors.paragrafo)}
                        helperText={formik.touched.paragrafo && formik.errors.paragrafo}
                    />
                </Grid>

                <Grid container justifyContent="center" size={12} sx={{ mt: 4 }}>
                    <Button
                        type="submit"
                        variant="contained"
                        startIcon={<Save />}
                        color="success"
                        onClick={formik.submitForm}
                    >
                        SALVAR TEXTO
                    </Button>
                </Grid>
            </Grid>
        </Modal>
    );
}